import { UnitTest } from "../UnitTestClass";
import { SCHEMAS } from "../../constants";
import { DataProcessing } from "../DataprocClass";

export const validateBattlecardTerritoryGroupTypesSchema = (dataset) => {
  // 1. Check schema
  const bcBuilderValidations = new UnitTest(dataset);
  const checkSchema = bcBuilderValidations.checkSchema(
    SCHEMAS.battlecardTerritoryGroupTypesSchema
  );
  return { checkSchema };
};

export const validateBattlecardTerritoryGroupTypesIntra = (dataset) => {
  const bcBuilderValidations = new UnitTest(dataset);
  const bcBuilderPreProcessing = new DataProcessing(dataset);
  // 1. Duplicates Test on BattlecardName
  //const duplicatesTest = bcBuilderValidations.checkDuplicates("BattlecardName");
  // 2. default test that returns true for our test cases
  // 3. Check that All Non-Null Parent Values exist in the Battlecard array
  const precedentValues =
    bcBuilderPreProcessing.extractValuesByProperty("Precedence").column_data;
  const precedenceTest = bcBuilderValidations.checkExistsIn(
    [1],
    precedentValues,
    "Precedence"
  );

  return { precedenceTest };
};
